import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import firebase from "firebase"



ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
if ('serviceWorker' in navigator ) {
  if (firebase.messaging.isSupported()) {
  

    console.log('Service Worker and Push is supported');
  
    navigator.serviceWorker.register('./js/firebase-messaging-sw.js')
    .then(function(swReg) {
      console.log('Service Worker is registered', swReg);
  
     
    })
    .catch(function(error) {
      console.error('Service Worker Error', error);
    });}
    else
    {
      console.warn('Push messaging is not supported');

    }
  } else {
    console.warn('Push messaging is not supported');
   
  }



// WEBPACK FOOTER //
// ./src/index.js